import React from 'react';
import { Card, Descriptions } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import IntlMessage from "../../../../components/IntlMessage/IntlMessage";

const UserProfile = () => {
    const { user } = useSelector(state => state.user);

    return (
        <Card 
            title={
                <>
                    <UserOutlined style={{ marginRight: 8 }} />
                    <IntlMessage id={'dashboard.user.profile.title'} fallback={'Профиль пользователя'} />
                </>
            }
            style={{ height: '100%' }}
        >
            <Descriptions column={1} bordered>
                <Descriptions.Item label={<IntlMessage id={'username'} fallback={'Имя пользователя'} />}>
                    {user?.username || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'fullName'} fallback={'ФИО'} />}>
                    {user?.profile?.fullName || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'iin'} fallback={'ИИН'} />}>
                    {user?.profile?.iin || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'phone'} fallback={'Контактный телефон'} />}>
                    {user?.profile?.telNumber || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'email'} fallback={'Email'} />}>
                    {user?.profile?.email || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'registrationAddress'} fallback={'Адрес регистрации'} />}>
                    {user?.profile?.registrationAddress || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'residenceAddress'} fallback={'Адрес фактического проживания'} />}>
                    {user?.profile?.residenceAddress || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'businessType'} fallback={'Тип хозяйства'} />}>
                    {user?.profile?.businessType || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'organizationName'} fallback={'Название организации'} />}>
                    {user?.profile?.organizationName || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bin'} fallback={'БИН'} />}>
                    {user?.profile?.bin || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'position'} fallback={'Должность'} />}>
                    {user?.profile?.position || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'authorityBasis'} fallback={'Основание полномочий'} />}>
                    {user?.profile?.authorityBasis || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankAccount'} fallback={'ИИК (банковский счет)'} />}>
                    {user?.profile?.bankAccount || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankBik'} fallback={'БИК банка'} />}>
                    {user?.profile?.bankBik || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'bankName'} fallback={'Название банка'} />}>
                    {user?.profile?.bankName || 'Не указано'}
                </Descriptions.Item>
                <Descriptions.Item label={<IntlMessage id={'role'} fallback={'Роль'} />}>
                    {user?.role?.roleName?.toUpperCase() || 'USER'}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default UserProfile;